jQuery(function($){
	$('.co-child-menu-footer .search-params .modify-wrapper .modify-params').on('click', function(e){
		e.preventDefault();
		
		let parentDiv = $(this).closest('.search-params');
		parentDiv.find('.sc-field-editor').toggleClass('expanded');
	});
});